import { animate, style, transition, trigger } from '@angular/animations';
import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	HostBinding,
	Input,
	Output,
} from '@angular/core';

import { ChatMessageModel } from './chat-message.model';

@Component({
	selector: 'spr-chat-message',
	templateUrl: './chat-message.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [
		trigger('inOut', [
			transition('void => left', [
				style({ transform: 'translateX(-100%)' }),
				animate('150ms', style({ transform: 'translateX(0)' })),
			]),
			transition('void => right', [
				style({ transform: 'translateX(100%)' }),
				animate('150ms', style({ transform: 'translateX(0)' })),
			]),
		]),
	],
	host: {
		class: 'flex items-stretch flex-col',
	},
})
export class ChatMessageComponent {
	@Input() @HostBinding('@inOut') public inOut = 'right';
	@Input() public message: ChatMessageModel;

	@Output() public visioOpen = new EventEmitter<string>();

	constructor(public el: ElementRef) {}

	public scrollTo(): void {
		this.el.nativeElement.scrollIntoView();
	}
}
